<template>
  <div id="the-app">
    <UseGetPicaForYourEvent/>
    <TheHeader v-if="isAuthenticated"/>
    <ModalCheckinMaker v-if="isAuthenticated"/>
    <ModalPreCheckinDataCollector v-if="isAuthenticated"/>
    <ModalPreCheckinFaceRecognition v-if="isAuthenticated"/>
    <ModalCheckinOptions v-if="isAuthenticated"/>
    <ModalMarketingConsent v-if="isAuthenticated"/>
    <div class="noty-custom-container"></div>
    <div class="router-container">
      <router-view :key="$route.fullPath" ref="refView"/>
    </div>
    <ModalMinimumAge v-if="minRequiredAge"/>
    <TheFooter/>
  </div>
</template>


<script>
import {getBrowserLanguage, i18n} from './i18n'

import {mapGetters} from 'vuex'
import TheHeader from "@/components/TheHeader"
import TheFooter from "@/components/TheFooter"
import ModalCheckinMaker from "@/components/ModalCheckinMaker"
import ModalPreCheckinDataCollector from "@/domain/checkin/ModalPreCheckinDataCollector"
import ModalPreCheckinFaceRecognition from "@/domain/checkin/ModalPreCheckinFaceRecognition"
import ModalMarketingConsent from "@/components/ModalMarketingConsent"
import ModalCheckinOptions from "@/domain/checkin/ModalCheckinOptions.vue";
import UseGetPicaForYourEvent from "@/domain/bannerGetPica/UseGetPicaForYourEvent.vue";
import ModalMinimumAge from "@/components/ModalMinimumAge.vue";

export default {
  name: 'App',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: i18n.t('seo.title'),
    // all titles will be injected into this template
    titleTemplate: '%s',
    htmlAttrs: {
      lang: getBrowserLanguage(),
      amp: true
    },
    meta: [
      // vmid will be used to substitute the existing tag
      {vmid: 'description', name: 'description', content: i18n.t('seo.meta_description')}
    ]
  },

  components: {
    ModalMinimumAge,
    UseGetPicaForYourEvent,
    TheHeader,
    TheFooter,
    ModalCheckinMaker,
    ModalPreCheckinDataCollector,
    ModalPreCheckinFaceRecognition,
    ModalMarketingConsent,
    ModalCheckinOptions,
  },

  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapGetters('appConfig', [
      'hideCart', 'minRequiredAge', "getAppConfigReady"
    ]),
  },

  watch: {
    isAuthenticated() {
      this.handleWebSocketConnection()
    }
  },

  mounted() {
    this.handleWebSocketConnection()
    this.handleWebSocketCheckinEvents()


    // Disable right click
    if (process.env.NODE_ENV !== "development") {
      document.body.addEventListener('contextmenu', evt => {
        evt.stopPropagation()
        evt.preventDefault()
      })
    }
  },

  beforeDestroy() {
    this.$store.dispatch('websocket/close')
    if (this.checkinEventsHandler) {
      this.$store.dispatch('websocket/unsubscribeOnMessageHandler', this.checkinEventsHandler)
      this.checkinEventsHandler = undefined
    }

  },

  methods: {
    handleWebSocketConnection() {
      if (this.isAuthenticated) {
        this.$store.dispatch('websocket/connect')
      } else {
        this.$store.dispatch('websocket/close')
      }
    },
    handleWebSocketCheckinEvents() {
      if (this.checkinEventsHandler) return
      this.checkinEventsHandler = (message) => {
        if (message.type === 'checkin.new_medias_found') {
          const picacode = message.data.picacode
          const checkin = this.$store.state.digitalItems.checkins.find(i => i.picacode === picacode)
          if (checkin) {
            const newMediasCount = message.data.media_ids.length - checkin.photos_count
            let msg = this.$tc('notifications.new_medias_found', newMediasCount, {count: newMediasCount})
            if (this.$router.currentRoute.name === 'checkins-detail' && this.$router.currentRoute.params.picacode === picacode) {
              this.$bvToast.toast(`${msg}`)
            } else {
              if (this.$router.currentRoute.name === 'checkins-list') {
                this.$store.dispatch('digitalItems/updateCheckin', checkin.id).then(() => {
                })
              }
              this.$bvToast.toast(
                  msg + this.$t('notifications.new_medias_found_for', {event_name: checkin.pica_service.event_name}),
                  {to: {name: 'checkins-detail', params: {picacode: picacode}}}
              )
            }
          }
        }
      }
      this.$store.dispatch('websocket/subscribeOnMessageHandler', this.checkinEventsHandler)
    }
  }
}
</script>
